import React, { useEffect, useState, useContext } from 'react';
import { toast } from 'react-toastify';
import { authFetch, authPost } from '../../Utilities/Api'; // Adjusted path
import AuthContext from '../../context/AuthContext'; // Adjusted path

// Import the Children from the components folder
import IncomingFriendRequests from './components/IncomingFriendsRequests'; // Check exact filename spelling!
import SentFriendRequests from './components/SentFriendRequests';
import './RequestsHub.css';

const Requests = () => {
    const [activeTab, setActiveTab] = useState('incoming');
    const [incoming, setIncoming] = useState([]);
    const [sent, setSent] = useState([]);
    const [loading, setLoading] = useState(true);

    const { user } = useContext(AuthContext);

    // 1. Fetch Data
    useEffect(() => {
        if (!user) return;

        const loadData = async () => {
            setLoading(true);
            try {
                const [inRes, sentRes] = await Promise.all([
                    authFetch('/friends/requests'),
                    authFetch('/friends/sent-requests')
                ]);

                setIncoming(await inRes.json());
                setSent(await sentRes.json());
            } catch (err) {
                console.error(err);
                toast.error("Could not load requests");
            } finally {
                setLoading(false);
            }
        };

        loadData();
    }, [user]);

    // 2. Handlers
    const handleRespond = async (requesterId, isAccepted) => {
        try {
            const res = await authPost(`/friends/respond/${requesterId}`, { accepted: isAccepted });
            if (res.ok) {
                toast.success(isAccepted ? "Request Accepted" : "Request Declined");
                setIncoming(prev => prev.filter(req => req._id !== requesterId));
            }
        } catch (err) {
            toast.error("Failed to respond");
        }
    };

    const handleCancel = async (receiverId) => {
        try {
            const res = await authFetch(`/friends/cancel-request/${receiverId}`, { method: 'DELETE' });
            if (res.ok) {
                toast.success("Request Cancelled");
                setSent(prev => prev.filter(req => req._id !== receiverId));
            }
        } catch (err) {
            toast.error("Failed to cancel");
        }
    };

    if (loading) return <div className="page-wrapper"><div className="spinner"></div></div>;

    return (
        <div className="requests-hub-container">
            <h2>Friend Requests</h2>

            {/* Tabs */}
            <div className="hub-tabs">
                <button
                    className={`hub-tab ${activeTab === 'incoming' ? 'active' : ''}`}
                    onClick={() => setActiveTab('incoming')}
                >
                    Incoming ({incoming.length})
                </button>
                <button
                    className={`hub-tab ${activeTab === 'sent' ? 'active' : ''}`}
                    onClick={() => setActiveTab('sent')}
                >
                    Sent ({sent.length})
                </button>
            </div>

            {/* Content Area */}
            <div className="hub-content">
                {activeTab === 'incoming' ? (
                    <IncomingFriendRequests
                        requests={incoming}
                        onRespond={handleRespond}
                    />
                ) : (
                    <SentFriendRequests
                        requests={sent}
                        onCancel={handleCancel}
                    />
                )}
            </div>
        </div>
    );
};

export default Requests;